import dayjs from 'dayjs';
import { DiagramRow } from '@/types/leadsStats';

export function aggregateByDay(list: DiagramRow[] | undefined) {
    const map = new Map<string, number>();

    for (const row of list || []) {
        const day = dayjs(row.date).format('YYYY-MM-DD');
        const value = Number(row.count) || 0;

        map.set(day, (map.get(day) || 0) + value);
    }

    return map;
}

export function sortDays(days: Iterable<string>) {
    return Array.from(days).sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime(),
    );
}

export function normalizeSeries(days: string[], map: Map<string, number>): { x: string; y: number }[] {
    return days.map(day => (
        {
            x: day,
            y: map.get(day) ?? 0,
        }
    ));
}
